import { combineReducers } from 'redux';
import PoemData from './PoemReducer';

const rootReducer = combineReducers({
  PoemData,
});

export default rootReducer;
